import { Directive, OnDestroy, OnInit } from '@angular/core';

/**
 * The header sits on top of the blue banner on the pages that have one, so it has to give up its
 * own background there — that is what `blue-background-active` on `<body>` does.
 *
 * Put this on the `.blue-background` element itself, so the class lives exactly as long as the
 * banner does. It used to be toggled by hand from eight component constructors: pages that wanted
 * it added it, pages that did not want it removed it defensively, and any page that did neither
 * inherited whatever the last one left behind. A student redirected straight to the submitted page
 * got a transparent header with no banner under it.
 *
 * Handles `*ngIf` for free — the provider page shows its banner only for a disabled client, and
 * the class now follows.
 */
@Directive({
    selector: '[appBlueBackground]',
    standalone: true
})
export class BlueBackgroundDirective implements OnInit, OnDestroy {
    private static readonly BODY_CLASS = 'blue-background-active';

    ngOnInit(): void {
        document.body.classList.add(BlueBackgroundDirective.BODY_CLASS);
    }

    ngOnDestroy(): void {
        document.body.classList.remove(BlueBackgroundDirective.BODY_CLASS);
    }
}
